import { render, staticRenderFns } from "./ReportResults.vue?vue&type=template&id=632e1cd7"
import script from "./ReportResults.vue?vue&type=script&lang=js"
export * from "./ReportResults.vue?vue&type=script&lang=js"
import style0 from "./ReportResults.vue?vue&type=style&index=0&id=632e1cd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports